import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewEssRequest() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New self-service request"
      listPath="/panel/ess"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'employeeId', label: 'Employee', required: true },
            {
              key: 'requestType',
              label: 'Request type',
              type: 'select',
              required: true,
              options: [
                { value: 'leave', label: 'Leave' },
                { value: 'reimbursement', label: 'Reimbursement' },
                { value: 'loan', label: 'Loan advance' },
                { value: 'document', label: 'Document copy' },
              ],
            },
            { key: 'subject', label: 'Subject', required: true },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'amount', label: 'Amount (if applicable)', type: 'number' },
            { key: 'fromDate', label: 'From date', type: 'date' },
            { key: 'toDate', label: 'To date', type: 'date' },
            { key: 'reason', label: 'Reason / description', type: 'textarea' },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [{ key: 'attachmentUrl', label: 'Attachment URL', placeholder: 'https://…' }],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
